import React, { useState, useRef, useEffect } from "react";
import bodhibotlogo from "../assets/images/Bodhibotlogo.webp";
import { FaArrowUp } from "react-icons/fa";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import {ReadyState} from "react-use-websocket";
import {useLocation} from "react-router-dom";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import useWebSocket from "react-use-websocket";
import * as constants from "Constants";
import DOMPurify from "dompurify";
import { marked } from "marked";
import hljs from "highlight.js";
import "highlight.js/styles/github.css";
import "./Bodhibot.css";
import httpService from "services/httpService";

const Bodhibot = () => {
  const ICON_SIZE = 60;
  const MARGIN = 20;
  const CHATBOX_MIN_WIDTH = 380;
  const CHATBOX_MIN_HEIGHT = 490;
  const CHATBOX_MAX_WIDTH = 500;
  const CHATBOX_MAX_HEIGHT = 600;
  const MAX_QUERY_BOX_HEIGHT = 100;
  const PAGE_SIZE = 10;

  const ICON_MAX_X = window.innerWidth - ICON_SIZE - MARGIN;
  const ICON_MAX_Y = window.innerHeight - ICON_SIZE - MARGIN;
  const MAX_RECONNECT_TRY = 3;
  
  const typeMap = {
    CodeSnippet: "code",
    TestCaseDetail: "tc",
    ProblemStatement: "ps",
  };

   const reverseTypeMap = {
    code : "Code Snippet",
    tc : "TestCase Detail",
    ps : "Problem Statement",
  }

  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const [iconPos, setIconPos] = useState({
    left: window.innerWidth - ICON_SIZE - MARGIN,
    top: window.innerHeight - ICON_SIZE - MARGIN,
  });
  const [chatBotProperty, setChatBotProperty] = useState({
    left: window.innerWidth - CHATBOX_MIN_WIDTH - MARGIN,
    top: window.innerHeight - CHATBOX_MIN_HEIGHT - MARGIN,
    height: CHATBOX_MIN_HEIGHT,
    width: CHATBOX_MIN_WIDTH,
  });
  const [dragging, setDragging] = useState(false);
  const [dragMoved, setDragMoved] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const startPos = useRef({ x: 0, y: 0 });
  const [query,setQuery] = useState("");
  const [chat,setChat] = useState([]);
  const [queyBoxHeight,setQueryBoxheight] = useState();
  const [iconChatOffset, setIconChatOffset] = useState({ x: 0, y: 0 });
  const [isFocused, setIsFocused] = useState(false);
  const [contextType,setContextType] = useState(null);
  const [context,setContext] = useState(null);
  const [codeContextLanguage, setCodeContextLanguage] = useState(null);

  const iconRef = useRef(null);
  const chatboxRef = useRef(null);
  const textareaRef = useRef(null);
  const resizeDir = useRef(null);
  const chatscontainerBotomRef = useRef(null);
  const chatContainerRef = useRef(null);
  const [pageNo,setPageNo] = useState(1);
  const [hasMoreChat,SetHasMoreChats] = useState(true);
  const [shouldScrollBottom, setShouldScrollBottom] = useState(false);
  const streamingRef = useRef(null);
  const [, forceRender] = useState(0);
  const [bodhibotEnabled,setBodhibotEnabled] = useState(false);
  const [bodhibotLoggingEnabled, setBodhibotLoggingEnabled] = useState(false);
  const mode = useSelector((state) => state.userInfo.mode);
  const [showBotThinking,setShowBotThinking] = useState(false);
  const token = localStorage.getItem("token");
  
  useEffect(() => {
    if (!window.MathJax) {
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  const location = useLocation();
  const [chatContextType,setChatContextType] = useState(null);
  const [courseId,setCourseId] = useState();
  const [activityId, setActivityId] = useState();

  const [thinkingState, setThinkingState] = useState({});
  const pingIntervalId = useRef(null);
  const [closedStateMsg, setClosedStateMsg] = useState("Waiting for connection");
  
  const introAddedRef = useRef(false);
  const wsUrl = bodhibotEnabled ? constants.bodhibot_url : null;
  const totalReConnectTry = useRef(0);
  const reconnectState = useRef(true);
  const { sendJsonMessage, lastJsonMessage, readyState, getWebSocket } = useWebSocket(wsUrl, {
    onOpen: () => {
      sendJsonMessage({
        "type": "authenticate", 
        "token": token
      });
    },
    shouldReconnect: (closeEvent) => {
        if (closeEvent.code >= 4000) return false;
        if(totalReConnectTry.current > MAX_RECONNECT_TRY) return false;
        totalReConnectTry.current++;
        return true && reconnectState.current;
      },
    reconnectAttempts: 3,
  });

  const resetContext = () => {
    setContext(null);
    setContextType(null);
    setCodeContextLanguage(null);
  }

  const introMsg = () => {
    if (introAddedRef.current) return;
    introAddedRef.current = true;

    let currContext = chatContextType;
    let messages = [];

    if (currContext === "general") {
      messages = [
        "Hey! I’m BodhiBot 👋",
        "I’m here to help you with this course.",
        "Whenever you’re ready, just say Hi 😊"
      ];
    } else if (currContext === "programming") {
      messages = [
        "Hey! I’m BodhiBot 👋",
        "I’m here to help you with this programming problem.",
        "You can highlight any part of the problem statement, your code, or a test case and choose 'Ask BodhiBot' to get help. I already know the problem statement, so I can jump straight into your questions.",
        "Whenever you’re ready, just say Hi 😊"
      ];
    }

    messages.forEach((msg, index) => {
      setTimeout(() => {
        setChat(prevChat => [
          ...prevChat,
          {
            role: "assistant",
            content: msg,
            timestamp: new Date().toISOString(),
          }
        ]);
      }, index * 1500); // 600ms delay between messages
    });
  };

  const setStatusForAIThinking =(new_chat) => { 
    setThinkingState(prev => {
      const updated = { ...prev };

      new_chat.forEach(msg => {
        if(msg.role === "assistant"){
          if (updated[msg.id] === undefined) {
            updated[msg.id] = false;
          }
        }
      });
      return updated;
    });
  }
  const toggleThinking = (msgId) => {
    setThinkingState(prev => ({
      ...prev,
      [msgId]: !prev[msgId]
    }));
  };


  const loadPaginatedChat = async (contextType,contextId, page_no=pageNo) => {
    try {
      const url = constants.base_url + "/bodhibot/get_messages/" + contextId + `?type=${contextType}&page_no=${page_no}&page_size=${PAGE_SIZE}`;
      const response = await httpService.get(url);
      if(response.status === 200){
        const new_chat = Array.isArray(response.data.data.message_history)? response.data.data.message_history : [];
        new_chat.reverse();
        if(page_no==1){
          setChat(new_chat);
          setThinkingState({});
          setShouldScrollBottom(true);
        }
        else{
          setChat(prev_chat => [...new_chat,...prev_chat]);
        }
        setStatusForAIThinking(new_chat);
        setShowBotThinking(response.data.data.show_bot_thinking);
        setPageNo(prevPageNo => prevPageNo + 1);
        if(new_chat.length < 10){
          SetHasMoreChats(false);
        }
        else{
          SetHasMoreChats(true);
        }
      }
      else{
          displayGlobalMessage("Unexpected error, please try later!", "error");
      }
    }catch (error) {
      if(error.response && error.response.data) {
        displayGlobalMessage(error.response.data.error_msg, "error");
      }else{
        displayGlobalMessage("Error in loading chats.", "error");
      }
    }
  }

  const  handelScroll=async()=>{
    const container = chatContainerRef.current;
    if(!container) return;
    const oldHeight = container.scrollHeight;
    if (container.scrollTop === 0 && hasMoreChat) {
      const contextId = chatContextType==="programming" ? activityId : courseId;
      container.classList.add("animating");
      document.querySelectorAll(".chat-item").forEach(el => el.classList.add("shift-down"));
      await loadPaginatedChat(chatContextType,contextId);
      requestAnimationFrame(() => {
        const newHeight = container.scrollHeight;
        container.scrollTop = newHeight - oldHeight;
      });
      setTimeout(() => {
        container.classList.remove("animating");
        document
          .querySelectorAll(".chat-item")
          .forEach(el => el.classList.remove("shift-down"));
      }, 150);
    }
  }

  useEffect(() => {
    const fetchcontext= async()=>{
      if (!location || !location.pathname) return;
      const path = location.pathname;
      const programmingRegex =
        /^\/courseware\/course\/(\d+)\/content\/labs\/(\d+)\/programming\/(\d+)$/;

      const matchProgramming = path.match(programmingRegex);
      let contextChanged = false;
      let contextType = "";
      let contextId = 0;
      let page_no=0;
      let course_id=0;

      if (matchProgramming) {
        course_id = matchProgramming[1];
        const activity_id = matchProgramming[3];
        if(chatContextType==null || chatContextType!=="programming"){
          contextChanged = true;
          contextType = "programming";
          contextId = activity_id;
          page_no =1;
          setPageNo(1);
        }
        setChatContextType("programming");
        setCourseId(course_id);
        setActivityId(activity_id);
      } else {
        const courseRegex = /\/courseware\/course\/(\d+)/;
        const matchCourse = path.match(courseRegex);
        course_id = matchCourse ? matchCourse[1] : null;
        if(chatContextType==null || chatContextType!=="general"){
          contextChanged = true;
          contextType = "general";
          contextId= course_id;
          page_no = 1;
          setPageNo(1);
        }
        setChatContextType("general");
        setCourseId(course_id);
        setActivityId(null);
      }
      let bodhibot_enabled = await fetchBodhiBotVisibilityStatus(course_id);
      if(contextChanged && bodhibot_enabled){
        resetContext();
        loadPaginatedChat(contextType,contextId,page_no);
      }
    }
    fetchcontext();
    
  }, [location.pathname,mode]);


  const reRender = () => forceRender((x) => x + 1);

  const sendOnEnter = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  }

  const sendMessage = async () => {
    const messgae_json = {
      type: "user_message",
      message: query,
      context_type: context ? typeMap[contextType] : chatContextType,
      highlighted_context:  context|| "",
      ...( chatContextType === "programming" && activityId
          ? { program_id: activityId }
          : { course_id: courseId }),
      ...( codeContextLanguage 
          ? {language : codeContextLanguage}
          : {}),
    };

    if(readyState === ReadyState.OPEN ){
      const new_message = { role: "user", content: query,timestamp: new Date().toISOString(),  ...(contextType && context ? { context_type : typeMap[contextType], context } : {})}
      sendJsonMessage(messgae_json);
      setQuery("");
      setContextType(null);
      setContext(null);
      setCodeContextLanguage(null);
      let streamMsg = { role: "assistant", content: "", timestamp:new Date().toISOString(), thinking:true};
      setChat((prev) => [...prev, new_message, streamMsg]);
      setShouldScrollBottom(true);
      streamingRef.current = streamMsg;
    }
    else{
      displayGlobalMessage("Something went Wrong.");
    }
  };

  useEffect(() => {
    pingIntervalId.current = setInterval(() => {
      if (readyState === ReadyState.OPEN) {
        sendJsonMessage({
          "type": "ping"
        })
      }
    }, 30000)

    return () => {
      clearInterval(pingIntervalId.current);
      pingIntervalId.current = null
    };
  }, [readyState])

  useEffect(()=>{
    if(!lastJsonMessage) return;
    if (lastJsonMessage.status === "unauthorized") {
      getWebSocket()?.close();
      setClosedStateMsg("User Unauthorized");
      clearInterval(pingIntervalId.current);
      pingIntervalId.current = null;
    }
    else if(lastJsonMessage.status === "successful"){
      if(lastJsonMessage.type=== "<START_BB>"){
        if(streamingRef.current.thinking){
          streamingRef.current.thinking = false;
        }
      }
      else if(lastJsonMessage.type === "<TOKEN>"){
        streamingRef.current.content += (lastJsonMessage.bodhibot_response + " ");
        reRender();
      }
      else if(lastJsonMessage.type === "<THINKING>"){
        setShowBotThinking(lastJsonMessage.show_bot_thinking);
        streamingRef.current.bot_thinking = lastJsonMessage.bodhibot_response;
        streamingRef.current.id = lastJsonMessage.id;
      }
      else if(lastJsonMessage.type === "<END_BB>"){
        setChat(prev =>
          prev.map(m =>
            m === streamingRef.current
              ? (() => {
                  const { thinking, ...rest } = streamingRef.current; 
                  return { ...rest }; 
                })()
              : m
          )
        );
        setShouldScrollBottom(true);
        setStatusForAIThinking([streamingRef.current]);
        streamingRef.current = null;
      }
    }
    else if(lastJsonMessage.status==="failed"){
      if(lastJsonMessage.message.includes("Service is Unavailable")){
        streamingRef.current.content = lastJsonMessage.message;
        displayGlobalMessage("BodhiBot is under maintenance. Please try again later.", "error");
        getWebSocket()?.close();
        setClosedStateMsg("BodhiBot Under Maintenance");
        clearInterval(pingIntervalId.current);
        pingIntervalId.current = null;
        reconnectState.current = false;
      }
      else if(lastJsonMessage.message.includes("BodhiBot is turned off for this course")) {
        streamingRef.current.content = lastJsonMessage.message;
        displayGlobalMessage("BodhiBot is turned off, please refresh your page.", "error");
        getWebSocket()?.close();
        setClosedStateMsg("BodhiBot turned off — refresh page");
        clearInterval(pingIntervalId.current);
        pingIntervalId.current = null;
        reconnectState.current = false;
      }
      else{
        streamingRef.current.content = "Something Went Wrong";
      }
      
      streamingRef.current["error"] = true;
      if(streamingRef.current.thinking){
        streamingRef.current.thinking = false;
      }
      reRender();
      setChat(prev =>
          prev.map(m =>
            m === streamingRef.current
              ? (() => {
                  const { thinking, ...rest } = streamingRef.current; 
                  return { ...rest }; 
                })()
              : m
          )
        );
      setShouldScrollBottom(true);
      streamingRef.current = null;
    }
    else if(lastJsonMessage.status==="connection_dropped") {
      getWebSocket()?.close();
      setClosedStateMsg("Connection dropped — refresh page");
      clearInterval(pingIntervalId.current);
      pingIntervalId.current = null;
    }
    else if(lastJsonMessage.status==="connection_denied") {
      getWebSocket()?.close();
      setClosedStateMsg("Connection denied — logout from other devices");
      clearInterval(pingIntervalId.current);
      pingIntervalId.current = null;
    }
    else if(lastJsonMessage.health_status==="bodhibot_down") {
      getWebSocket()?.close();
      setClosedStateMsg("Bodhibot unavailable — try again later");
      clearInterval(pingIntervalId.current);
      pingIntervalId.current = null;
    }
  },[lastJsonMessage]);
  
  const adjustHeight = () => {
      const textarea = textareaRef.current;
      if (textarea) {
          textarea.style.height = 'auto'; 
          textarea.style.height = Math.min(textarea.scrollHeight, MAX_QUERY_BOX_HEIGHT) + 'px';
          setQueryBoxheight(Math.min(textarea.scrollHeight, MAX_QUERY_BOX_HEIGHT));
      }
  };

  useEffect(() => {
      adjustHeight();
  }, [query]);

  const scrollToBottom = () => {
    if (chatscontainerBotomRef.current) {
      chatscontainerBotomRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  };

  useEffect(() => {
    if (!shouldScrollBottom) return;
    requestAnimationFrame(() => {
      setTimeout(() => {
        scrollToBottom();
        setShouldScrollBottom(false);
      }, 0);   
    });
  }, [chat,shouldScrollBottom]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!dragging) return;

      const dx = Math.abs(e.clientX - startPos.current.x);
      const dy = Math.abs(e.clientY - startPos.current.y);
      if (dx > 3 || dy > 3) setDragMoved(true);

      document.body.style.userSelect = "none";
      let CHATBOX_MAX_X = window.innerWidth - chatBotProperty.width - MARGIN;
      let CHATBOX_MAX_Y = window.innerHeight - chatBotProperty.height - MARGIN;
      if (isChatbotOpen) {
        const newLeft = Math.min(Math.max(e.clientX - offset.x, MARGIN), CHATBOX_MAX_X);
        const newTop = Math.min(Math.max(e.clientY - offset.y, MARGIN), CHATBOX_MAX_Y);
        setChatBotProperty(prev => ({
          ...prev,
          left: newLeft,
          top: newTop
        }));
        setIconPos({
          left: newLeft + iconChatOffset.x,
          top: newTop + iconChatOffset.y,
        });
      } else {
        const newLeft = Math.min(Math.max(e.clientX - offset.x, MARGIN), ICON_MAX_X);
        const newTop = Math.min(Math.max(e.clientY - offset.y, MARGIN), ICON_MAX_Y);
        setIconPos({ left: newLeft, top: newTop });
      }
    };

    const handleMouseUp = () => {
      setDragging(false);
      setTimeout(() => setDragMoved(false), 50);
      document.body.style.userSelect = "";
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [dragging, offset, isChatbotOpen]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!resizeDir.current) return;
      e.preventDefault();

      setChatBotProperty((prev) => {
        let newWidth = prev.width;
        let newHeight = prev.height;
        let newLeft = chatBotProperty.left;
        let newTop = chatBotProperty.top;
        let iconLeft=iconPos.left;
        let iconTop=iconPos.top;
        let isChanged=false;

        switch (resizeDir.current) {
          case "top-left":
            if(e.clientX >= MARGIN){
              newWidth = Math.min(
                Math.max(prev.width - (e.clientX - chatBotProperty.left), CHATBOX_MIN_WIDTH),
                CHATBOX_MAX_WIDTH
              );
              newLeft = chatBotProperty.left + (prev.width - newWidth);
            }
            
            if(e.clientY>=MARGIN){
              newHeight = Math.min(
                Math.max(prev.height - (e.clientY - chatBotProperty.top), CHATBOX_MIN_HEIGHT),
                CHATBOX_MAX_HEIGHT
              );   
              newTop = chatBotProperty.top + (prev.height - newHeight);
            }
            if(newLeft>iconLeft){
              iconLeft = newLeft;
              isChanged = true;
            }
            if(newTop>iconTop){
              iconTop = newTop;
              isChanged = true;
            }
            break;

          case "top-right":
            if(e.clientX<=window.innerWidth-MARGIN){
              newWidth = Math.min(
                Math.max(e.clientX - chatBotProperty.left, CHATBOX_MIN_WIDTH),
                CHATBOX_MAX_WIDTH
              );
            }
            
            if(e.clientY>=MARGIN){
              newHeight = Math.min(
                Math.max(prev.height - (e.clientY - chatBotProperty.top), CHATBOX_MIN_HEIGHT),
                CHATBOX_MAX_HEIGHT
              );
              newTop = chatBotProperty.top + (prev.height - newHeight);
            }
            if(newLeft+newWidth<iconLeft+ICON_SIZE){
              iconLeft = newLeft+newWidth-ICON_SIZE;
              isChanged = true;
            }
            if(newTop>iconTop){
              iconTop = newTop;
              isChanged = true;
            }
            break;

          case "bottom-left":
            if(e.clientX>=MARGIN){
              newWidth = Math.min(
                Math.max(prev.width - (e.clientX - chatBotProperty.left), CHATBOX_MIN_WIDTH),
                CHATBOX_MAX_WIDTH
              );
              newLeft = chatBotProperty.left + (prev.width - newWidth);
            }
            if(e.clientY<=window.innerHeight-MARGIN){
              newHeight = Math.min(
                Math.max(e.clientY - chatBotProperty.top, CHATBOX_MIN_HEIGHT),
                CHATBOX_MAX_HEIGHT
              );
            }
            if(newLeft>iconLeft){
              iconLeft = newLeft;
              isChanged = true;
            }
            if(newTop+newHeight<iconTop+ICON_SIZE){
              iconTop = newTop + newHeight - ICON_SIZE;
              isChanged = true;
            }
            break;

          case "bottom-right":
            if(e.clientX<=window.innerWidth-MARGIN){
              newWidth = Math.min(
                Math.max(e.clientX - chatBotProperty.left, CHATBOX_MIN_WIDTH),
                CHATBOX_MAX_WIDTH
              );
            }
            if(e.clientY<=window.innerHeight-MARGIN){
              newHeight = Math.min(
                Math.max(e.clientY - chatBotProperty.top, CHATBOX_MIN_HEIGHT),
                CHATBOX_MAX_HEIGHT
              );
            }
            if(newLeft+newWidth<iconLeft+ICON_SIZE){
              iconLeft = newLeft+newWidth-ICON_SIZE;
              isChanged = true;
            }
            if(newTop+newHeight<iconTop+ICON_SIZE){
              iconTop = newTop + newHeight - ICON_SIZE;
              isChanged = true;
            }
            break;
        }
        if(isChanged){
          setIconPos({left:iconLeft, top: iconTop});
        }
        return { width: newWidth, height: newHeight ,left: newLeft, top: newTop};
      });
    };

    const handleMouseUp = () => {
      resizeDir.current = null;
      document.body.style.userSelect = "";
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [chatBotProperty]);


  const handleMouseDown = (e, isChatbox = false) => {
    const rect = isChatbox ? chatboxRef.current.getBoundingClientRect() : iconRef.current.getBoundingClientRect();
    setOffset({ x: e.clientX - rect.left, y: e.clientY - rect.top });
    startPos.current = { x: e.clientX, y: e.clientY };
    setDragging(true);
  };

  
  const handleToggle = () => {
    if (dragMoved) return;

    if (!isChatbotOpen) {
      const spaceRight = window.innerWidth - (iconPos.left + ICON_SIZE);
      const spaceBottom = window.innerHeight - (iconPos.top + ICON_SIZE);

      let left, top;

      if (spaceRight >= chatBotProperty.width + MARGIN) {
        left = iconPos.left;
      } else if (iconPos.left >= chatBotProperty.width + MARGIN) {
        left = iconPos.left + ICON_SIZE - chatBotProperty.width;
      } else {
        left = Math.min(
          Math.max(iconPos.left - chatBotProperty.width / 2, MARGIN),
          window.innerWidth - chatBotProperty.width - MARGIN
        );
      }

      if (spaceBottom >= chatBotProperty.height + MARGIN) {
        top = iconPos.top;
      } else if (iconPos.top >= chatBotProperty.height + MARGIN) {
        top = iconPos.top + ICON_SIZE - chatBotProperty.height;
      } else {
        top = Math.min(
          Math.max(iconPos.top - chatBotProperty.height / 2, MARGIN),
          window.innerHeight - chatBotProperty.height - MARGIN
        );
      }
      setChatBotProperty(prev => ({
        ...prev,
        left,
        top
      }));
      
      setIconChatOffset({
        x: iconPos.left - left,
        y: iconPos.top - top,
      });
      setShouldScrollBottom(true);
    }

    setIsChatbotOpen((prev) => !prev);
  };

  const externalData = useSelector((state) => state.chatbot.externalData);
  useEffect(() => {
    if(!externalData) return;
    let prev_chats = chat;
    if (externalData?.type === "codeSnippet") {
      if(context){
        prev_chats.pop();
      }
      setContextType("CodeSnippet");
      setContext(externalData?.content);
      setCodeContextLanguage(externalData?.language);
      const new_message = { role: "assistant", 
                            content: "Hey! Looks like you want to ask question related to code snippet. Please ask away and I'll do my best to answer.", 
                            timestamp: new Date().toISOString(),
                          };
      setChat([...prev_chats, new_message]);
      setShouldScrollBottom(true);
      setIsChatbotOpen(true);
    }
    else if(externalData?.type === "testcaseDetail"){
      if(context){
        prev_chats.pop();
      }
      setContextType("TestCaseDetail");
      setContext(externalData?.content);
      const new_message = { role: "assistant", 
                            content: "Hey! Looks like you want to ask question related to the testcase. Please ask away and I'll do my best to answer.", 
                            timestamp: new Date().toISOString(),
                          };
      setChat([...prev_chats, new_message]);
      setShouldScrollBottom(true);
      setIsChatbotOpen(true);
    }
    else if(externalData?.type === "problemStatement"){
      if(context){
        prev_chats.pop();
      }
      setContextType("ProblemStatement");
      setContext(externalData?.content);
      const new_message = { role: "assistant", 
                            content: "Hey! Looks like you want to ask question related to the problem statement. Please ask away and I'll do my best to answer.", 
                            timestamp: new Date().toISOString(),
                          };
      setChat([...prev_chats, new_message]);
      setShouldScrollBottom(true);
      setIsChatbotOpen(true);
    }
    else{
      return;
    }
  }, [externalData]);

  const fetchBodhiBotVisibilityStatus = async (course_id)=>{
    try {
      const url = constants.base_url + "/bodhibot/status/" + course_id;
      const response = await httpService.get(url, { skipErrorToast: true });
      if(response?.status === 200){
        setBodhibotLoggingEnabled(response?.data?.data?.enable_bodhibot_logging);
        if(response?.data?.data?.enable_bodhibot){
          setBodhibotEnabled(true);
          return true;
        }

      }
      return false;
    }
    catch (error) {
      if (error.response && (error.response.status === 403 || error.response.status === 404)) {
        // Expected for unenrolled students — silently disable bodhibot
        return false;
      }
      if(error.response && error.response.data) {
        displayGlobalMessage(error.response.data.error_msg, "error");
      }else{
        displayGlobalMessage("Something Went Wrong in Bodhibot.", "error");
      }
      return false;
    }   
  }

  const printTestCaseObj=(testCaseObj)=>{
    if (typeof testCaseObj === "string") {
      try {
        testCaseObj = JSON.parse(testCaseObj.replace(/'/g, '"'));
      } catch (e) {
        console.log("Failed to parse test case:");  
      }
    }
    let testcaseDeail = "Input: " + testCaseObj?.input + "\n";
    testcaseDeail += ("Expected Output: " + testCaseObj?.expected_output + "\n");
    testcaseDeail += (("Actual Output: " + testCaseObj?.actual_output || '') + "\n");
    return testcaseDeail;
  };

  const removeContext=()=>{
    setContext(null);
    setContextType(null);
    setCodeContextLanguage(null);
    setChat(prev => [...prev.slice(0, -1)]);
  }

  const fixLaTeX = (raw)=> {
    if (!raw) return "";
    return raw
      .replace(/\\{2,}\(/g, "\\(")
      .replace(/\\{2,}\)/g, "\\)")
      .replace(/\\{2,}\[/g, "\\[")
      .replace(/\\{2,}\]/g, "\\]")
      .trim();
  }

  useEffect(() => {
    if (!chatContainerRef.current) return;
    chatContainerRef.current.querySelectorAll("pre code").forEach(block => {
      hljs.highlightElement(block);
    });
    if (window.MathJax) {
      window.MathJax.typesetPromise([chatContainerRef.current]);
    }

  }, [chat]);

  return (
    <>
    {bodhibotEnabled && (
      <div key="bodhibot">
        {!isChatbotOpen ? (
          <img
            ref={iconRef}
            src={bodhibotlogo}
            style={{
              position: "fixed",
              left: iconPos.left,
              top: iconPos.top,
              width: ICON_SIZE,
              height: ICON_SIZE,
              borderRadius: "50%",
              cursor: "grab",
              userSelect: "none",
              border: "2px solid rgba(255,255,255,0.8)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.25), 0 0 8px rgba(0,123,255,0.3)",
              backgroundColor: "white",
              zIndex: 1200,
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
            }}
            onMouseDown={(e) => handleMouseDown(e)}
            onClick={handleToggle}
            draggable={false}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow =
                "0 6px 16px rgba(0,0,0,0.3), 0 0 10px rgba(0,123,255,0.5)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(0,0,0,0.25), 0 0 8px rgba(0,123,255,0.3)";
            }}
          />
        ) : (
          <div
            ref={chatboxRef}
            style={{
              position: "fixed",
              left: chatBotProperty.left,
              top: chatBotProperty.top,
              width: chatBotProperty.width,
              height: chatBotProperty.height,
              backgroundColor: "#ffffff",
              border: "1px solid #e0e0e0",
              borderRadius: "12px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
              display: "flex",
              flexDirection: "column",
              zIndex: 1200,
              overflow: "hidden",
              transition: "box-shadow 0.3s ease",          
              minWidth: CHATBOX_MIN_WIDTH,            
              minHeight: CHATBOX_MIN_HEIGHT,            
              maxWidth: CHATBOX_MAX_WIDTH, 
              maxHeight: CHATBOX_MAX_HEIGHT, 
              boxShadow: dragging
                ? "0 0 0 2px rgba(0,123,255,0.2)"
                : "0 8px 24px rgba(0,0,0,0.15)",
              cursor: dragging ? "grabbing" : "default",
            }}
          >
            <div
              style={{
                background: "#007bff",
                color: "white",
                padding: "10px 14px",
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "grab",
                height: "55px",
                fontSize : "20px",
                fontWeight: "550",
                letterSpacing: "0.5px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}
              onMouseDown={(e) => handleMouseDown(e, true)}
            >
              <span>BodhiBot</span>
              <button
                onClick={handleToggle}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "white",
                  fontSize: "18px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  transition: "transform 0.2s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              >
                ✕
              </button>
            </div>
            <div
            ref={chatContainerRef}
            onScroll={handelScroll}
              style={{
                flex: 1,
                padding: "12px",
                overflowY: "auto",
                backgroundColor: "#f5f7fb",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                scrollBehavior: "auto",
              }}
            >
              
            {chat?.length > 0 ? (chat.map((msg, index) => (
              <div
                key={msg.id}
                className="chat-item"
                style={{
                  display: "flex",
                  justifyContent: msg.role === "user" ? "flex-end" : "flex-start",
                  animation: "fadeIn 0.3s ease",
                  marginBottom: "8px",
                }}
              >
                <div
                  style={{
                    backgroundColor: msg.role === "user" ? "#007bff34" : "#e5e7eb",
                    color: "#111827",
                    padding: "5px",
                    borderRadius:
                      msg.role === "user"
                        ? "16px 16px 4px 16px"
                        : "16px 16px 16px 4px",
                    minWidth:"60%",
                    maxWidth: "80%",
                    wordWrap: "break-word",
                    boxShadow: "0 1px 6px rgba(0,0,0,0.1)",
                    fontSize: "14px",
                    transition: "background 0.3s ease",
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                    ...(msg.error
                      ? {
                        border: "1px solid red"
                        }
                      : {})
                  }}
                >
                  {msg.role === "user" && msg.context && (
                    <div
                      style={{
                        backgroundColor: "#f3f6fa",
                        padding: "2px 8px",
                        borderRadius: "12px",
                        boxShadow: "inset 0 0 2px rgba(0,0,0,0.05)",
                        display: "flex",
                        flexDirection: "column",
                        maxWidth: "100%",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "#007bff",
                          marginBottom: "1px",
                        }}
                      >
                        {reverseTypeMap[msg.context_type]}
                      </span>
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#333",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          whiteSpace: "pre-wrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          lineHeight: "1.4",
                          wordBreak: "break-word",
                        }}
                      >
                        {msg?.context_type==="tc" ? printTestCaseObj(msg?.context) : msg?.context}
                      </span>
                    </div>
                  )}

                  {('thinking' in msg && msg.thinking) ? (
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems:"flex-end",padding: "12px 8px 8px 8px", gap: "4px" }}>
                      {[0, 1, 2].map((i) => (
                        <span
                          key={i}
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor: "#78797aff",
                            animation: "jump 1.2s ease-in-out infinite",
                            animationDelay: `${i * 0.15}s`,
                          }}
                        />
                      ))}

                      <style>
                        {`
                          @keyframes jump {
                            0%, 80%, 100% {
                              transform: scale(1);
                              border-radius: 50%;
                              opacity: 0.5;
                            }
                            40% {
                              transform: translateY(-6px) scaleX(1.2) scaleY(0.8);
                              border-radius: 40%;
                              opacity: 1;
                            }
                          }
                        `}
                      </style>
                    </div>
                  ) : (
                    <div>
                      {msg?.role === "assistant" && showBotThinking && thinkingState[msg?.id] !== undefined && (
                        <>
                            <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              marginBottom: "0px",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                              backgroundColor: "transparent",
                              borderRadius: "8px",
                              cursor: "pointer",
                              userSelect: "none",
                              transition: "background-color 0.18s ease, transform 0.18s ease",
                            }}

                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#d9dae0ff"; 
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = "transparent";
                            }}

                            onClick={() => toggleThinking(msg.id)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") toggleThinking(msg.id);
                            }}
                            aria-expanded={!!thinkingState[msg.id]}
                          >
                            <span
                              style={{
                                fontSize: 15,
                                color: "#334155",
                                fontWeight: 600,
                              }}
                            >
                              {thinkingState[msg.id] ? "Hide Bodhibot Thinking" : "Show Bodhibot Thinking"}
                            </span>

                            {!thinkingState[msg.id] ? (
                              <RiArrowDownSLine
                                style={{
                                  fontSize: 18,
                                  color: "#334155",
                                  transition: "transform 0.18s ease",
                                }}
                              />
                            ) : (
                              <RiArrowUpSLine
                                style={{
                                  fontSize: 18,
                                  color: "#334155",
                                  transition: "transform 0.18s ease",
                                }}
                              />
                            )}
                          </div>

                          {thinkingState[msg.id] && (
                            <div
                              style={{
                                backgroundColor: "#f3f6fa",
                                border: "1px solid #e2e6ea",
                                padding: "6px 12px",
                                fontSize: 13,
                                color: "#374151",
                                lineHeight: 1.45,
                                fontWeight:200,
                                boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
                                animation: "fadeIn 0.2s ease",
                              }}
                            >
                              {msg.bot_thinking || "AI thinking not available."}
                              {/* {renderThinking(msg.bot_thinking,msg.id)} */}
                            </div>
                          )}

                          </>
                      )}

                      <div
                        style={{
                          margin: 0,
                          fontFamily: "inherit",
                          wordBreak: "break-word", 
                          padding:"6px 10px",
                          ...( msg.error 
                            ? {color: "#b00000c5",}
                            : {}
                          )
                        }}
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(marked.parse(fixLaTeX(msg.content) || "")) }}
                        className="markdown-body"
                      >
                      </div>
                    </div>
                  )}   
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#6b7280",
                      textAlign: "right",
                    }}
                  >
                    {new Date(msg.timestamp).toLocaleTimeString([], {
                      year: "numeric",
                      month: "short",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </div>
                </div>
              </div>
            ))):
              introMsg()
            // (
            //   <div
            //     style={{
            //       position: "absolute",
            //       top: "50%",
            //       left: "50%",
            //       transform: "translate(-50%, -50%)",
            //       textAlign: "center",
            //       color: "#999",
            //       fontSize: "16px",
            //       fontWeight: "500",
            //     }}
            //   >
            //     No messages to show...
            //   </div>
            // )
          }
              <div ref={chatscontainerBotomRef} />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "space-between",
                background: "#ffffff",
                borderTop: "1px solid #e0e0e0",
                padding: "8px 8px 2px 8px",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  background: "#ffffff",
                  borderRadius: "14px",
                  transition: "box-shadow 0.25s ease, border 0.25s ease",
                  width: chatBotProperty.width - (16 + 42),
                  boxShadow: isFocused
                    ? "0 0 0 2px rgba(25, 118, 210, 0.35)" 
                    : "0 1px 3px rgba(0,0,0,0.08)",
                  border: isFocused
                    ? "1px solid rgba(25, 118, 210, 0.4)"
                    : "1px solid rgba(0,0,0,0.08)",
                }}
              >
                {contextType &&
                
                  <div
                    style={{
                      backgroundColor: "#f3f6fa",
                      padding: "6px 10px",
                      marginBottom: "6px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      boxShadow: "inset 0 0 2px rgba(0,0,0,0.05)",
                      borderRadius: "14px",
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#007bff",
                          marginBottom: "2px",
                        }}
                      >
                        {contextType}
                      </span>
                    <span
                      style={{
                        fontSize: "13px",
                        color: "#333",
                        display: "-webkit-box",           
                        WebkitLineClamp: 2,              
                        WebkitBoxOrient: "vertical", 
                        whiteSpace: "pre-wrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        lineHeight: "1.4",
                        wordBreak: "break-word",
                      }}
                    >
                      {context != null ? (contextType==="TestCaseDetail" ? printTestCaseObj(context) : context) : ""}
                    </span>
                    </div>
                    <button
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "#999",
                        fontSize: "16px",
                        cursor: "pointer",
                        marginLeft: "8px",
                        transition: "color 0.2s ease",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = "#333")}
                      onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
                      onClick={()=>{removeContext();}}
                    >
                      ✕
                    </button>
                  </div>
                }
              
                <textarea
                  ref={textareaRef}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  rows={1}
                  placeholder={
                    readyState !== ReadyState.OPEN
                      ? `${closedStateMsg}...`
                      : "Ask Your Query..."
                  }
                  readOnly={readyState !== ReadyState.OPEN}
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  onKeyDown={sendOnEnter}
                  style = {{
                    width: "100%",
                    padding: "8px 10px",
                    resize: "none",
                    outline: "none",
                    borderRadius: "10px",
                    fontFamily: "'Arial', sans-serif",
                    fontSize: "15px",
                    lineHeight: "1.5",
                    maxHeight: `${MAX_QUERY_BOX_HEIGHT}px`,
                    overflowY: "auto",
                    transition: "all 0.25s ease",
                    color: "#222",
                    background: readyState=== ReadyState.OPEN ? "transparent" : "rgba(0, 0, 0, 0.1)",         

                    border: readyState=== ReadyState.OPEN
                      ? "none"                     
                      : "1px solid rgba(0, 0, 0, 0.51)",   
                    opacity: readyState=== ReadyState.OPEN ? 1 : 0.85,
                    cursor: readyState=== ReadyState.OPEN ? "text" : "not-allowed",
                  }}
                />
              </div>

              <Button
                className="send-button"
                variant="primary"
                aria-label="Submit Query"
                style={{
                  border: "none",
                  borderRadius: "50%",
                  color: "white",
                  height: "35px",
                  width: "35px",
                  marginBottom: "2px",
                  padding: 0,
                  background: "#007bff",
                  boxShadow: "0 2px 6px rgba(0, 123, 255, 0.4)",
                  transition: "background 0.2s ease, transform 0.1s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#0069d9")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "#007bff")}
                onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.95)")}
                onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
                onClick={()=>{sendMessage();}}
                disabled={query.trim().length === 0 || readyState!== ReadyState.OPEN || streamingRef.current}
              >
                <FaArrowUp size={18} />
              </Button>
            </div>
            <span style={{display: "block", background: "transparent", color: "rgba(78, 75, 75, 1)", fontSize: "11px", padding: "2px 0", textAlign: "center", letterSpacing: "0.3px" }}>
              These responses are AI-generated and may be wrong.<br/>{bodhibotLoggingEnabled && "Your chat is being recorded."}
            </span>


            {["top-left", "top-right", "bottom-left", "bottom-right"].map((pos) => (
              <div
                key={pos}
                onMouseDown={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  resizeDir.current = pos;
                  document.body.style.userSelect = "none";
                }}
                style={{
                  position: "absolute",
                  width: "12px",
                  height: "12px",
                  zIndex: 1200,
                  background: "transparent", 
                  ...(pos === "top-left" && { top: 0, left: 0, cursor: "nwse-resize" }),
                  ...(pos === "top-right" && { top: 0, right: 0, cursor: "nesw-resize" }),
                  ...(pos === "bottom-left" && { bottom: 0, left: 0, cursor: "nesw-resize" }),
                  ...(pos === "bottom-right" && { bottom: 0, right: 0, cursor: "nwse-resize" }),
                }}
              />
            ))}
          </div>
        )}
      </div>
    )}
    </>
  );
};

export default Bodhibot;
